module.exports = __webpack_public_path__ + "img/elderflower-cooler.e80e747e.jpg";